import { ChipsContainer, CollectionsFilterTitle, ViewMoreButton, FilterSection } from './styles';
import React, { useCallback, useRef } from 'react';

import { CollectionsComponent } from 'components/collections-component';
import { useBooleanState } from '@hqo/react-components-library/dist/hooks';
import { useIntl } from 'react-intl';
import { useCollectionsFilter } from './use-collections-filter.hook';
import { useGetResourceCollectionsQuery } from 'store/collections/hooks';
import { useIsChipsContainerOverflowing } from './use-is-chips-container-overflowing.hook';

export const CollectionsFilter = (): JSX.Element => {
  const { value: isChipContainerExpanded, toggle: toggleIsChipContainerExpanded } = useBooleanState(false);
  const { data: collections } = useGetResourceCollectionsQuery();
  const { selectedCollections, onCollectionChipClickHandler } = useCollectionsFilter();
  const chipsContainerRef = useRef<HTMLDivElement>(null);
  const isOverflowing = useIsChipsContainerOverflowing(chipsContainerRef, collections?.length ?? 0);

  const intl = useIntl();
  const handleToggleIsChipContainerExpanded = useCallback(() => {
    toggleIsChipContainerExpanded();
  }, [toggleIsChipContainerExpanded]);

  return collections?.length ? (
    <FilterSection>
      <CollectionsFilterTitle>{intl.formatMessage({ id: 'collections' })}</CollectionsFilterTitle>
      <ChipsContainer isExpanded={isChipContainerExpanded} ref={chipsContainerRef}>
        <CollectionsComponent
          collections={collections}
          selectedCollections={selectedCollections}
          onCollectionChipClickHandler={onCollectionChipClickHandler}
        />
      </ChipsContainer>
      {isOverflowing && (
        <ViewMoreButton
          text={intl.formatMessage({ id: isChipContainerExpanded ? 'hideCollections' : 'viewMore' })}
          variant="closeButton"
          onClick={handleToggleIsChipContainerExpanded}
          multiline={false}
        />
      )}
    </FilterSection>
  ) : null;
};
